module.exports = "query Users (\n  $company: String = \"\",\n  $search: String = \"\",\n  $page: Int = 1, \n  $limit: Int = 10,\n  $asc: String = \"name\",\n  $status: String)\n{\n  users (\n    page: $page,\n    limit: $limit,\n    asc: $asc,\n    status: $status,\n    search: $search,\n    company: $company\n  ) {\n    data {\n      id\n      name\n      email\n      document\n      companies {\n        id\n        company_id\n        name\n      }\n      status\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/UserCashback.graphql
// module id = mbVt
// module chunks = 1624